<template>
    <div class="modules-create-modal">
        <ModalContainer :title="$t('modules.add_module')" identifier="modules-create-modal" :closable="true">
            <Form class="form" @submit="save" :disabled="is_saving">
                <FormInputText v-model="$v.module.name.$model" ref="name" identifier="name" :label="$t('modules.name')"
                               :disabled="is_saving" :has-error="$v.module.name.$error">
                    <template v-slot:errors>
                        <p v-if="!$v.module.name.required">
                            {{ $t('validation.x_is_required', {x: $t('modules.name')}) }}
                        </p>
                    </template>
                </FormInputText>

                <Button type="submit" className="--primary --small" :class="{spinner: is_saving}">
                    {{ $t('save') }}
                </Button>
            </Form>
        </ModalContainer>
    </div>
</template>

<script>
import ModalContainer from "../modal/ModalContainer";
import Form from "../form/Form";
import FormInputText from "../form/FormInputText";
import FormInputSelect from "../form/FormInputSelect";
import {required} from 'vuelidate/lib/validators'
import Button from "../Button";

export default {
    name: "ModulesCreateModal",
    components: {Button, FormInputSelect, FormInputText, Form, ModalContainer},
    data() {
        return {
            module: {
                name: null,
            },
            is_saving: false,
        }
    },
    validations: {
        module: {
            name: {required},
        }
    },
    methods: {
        close(status) {
            this.$modal.hide('modules-create-modal', status);
        },
        save() {
            this.$v.module.$touch();
            if (this.$v.module.$anyError || this.is_saving) return;

            this.is_saving = true;

            this.$axios.post(`modules`, {name: this.module.name})
                .then(({data}) => {
                    this.close(true);
                    this.is_saving = false;
                }).catch(e => {
                    this.is_saving = false;

                    this.$notify({
                        title: this.$t('error'),
                        text: this.$larerror(e.response.data.errors, this.$t('modules.error_create')),
                        type: 'error',
                    });
                });
        },
    },
    mounted() {
        this.$refs.name.$el.children[1].focus();
    }
}
</script>


<style lang="scss" scoped>
.select {
    @apply mb-5;
}
</style>